'use client';

import addToCartTrigger from '@coolblue-development/ga4-events/triggers/OrderBlock/addToCartTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { AddToCartButton } from '@coolblue-development/next-shopping-cart/client';
import { OrderBlockContext } from '@features/product/context';
import { useTranslation } from '@i18n/useTranslation';
import { useContext } from 'react';

export const AddToCartContainer = ({
  productId,
  isLoading,
  disabled,
  formId
}: {
  productId: number;
  disabled: boolean;
  isLoading?: boolean;
  formId?: string;
}) => {
  const { trackEvent } = useAnalytics();
  const { isCustomerFacingEmployee } = useContext(OrderBlockContext);

  const { t } = useTranslation('webshop');

  const trackingEvent = () => {
    trackEvent(
      addToCartTrigger({
        item_id: productId,
        order_type: 'purchase'
      })
    );
  };

  return (
    <AddToCartButton
      isFullWidth
      label={t(`orderBlock.addToCart.${isCustomerFacingEmployee ? 'storeEmployeeLabel' : 'label'}`)}
      onSuccess={() => trackingEvent()}
      loading={isLoading}
      disabled={disabled}
      form={formId}
    />
  );
};
